import CiqDocumentView from "components/ciq-pdf-viewer/ciq-pdf-document";
import { useMemo } from "react";

import { CloseOutlined } from "@ant-design/icons";
import { MaterialExtractSpecType } from "../model";

function ExtractedPdfViewer({
  onClose,
  extrationData
}: {
  onClose: () => void;
  extrationData: MaterialExtractSpecType | undefined;
}) {
  const boundingBoxPossition = useMemo(
    () =>
      extrationData?.spec_page_extract
        ? {
            width: extrationData.spec_page_extract.spec_page.width,
            height: extrationData.spec_page_extract.spec_page.height,
            x1: extrationData.spec_page_extract.bb_x1,
            x2: extrationData.spec_page_extract.bb_x2,
            y1: extrationData.spec_page_extract.bb_y1,
            y2: extrationData.spec_page_extract.bb_y2,
            page_no: 0
          }
        : undefined,
    [extrationData]
  );

  return (
    <div className="flex-col grow border-0 border-t border-solid border-black border-opacity-10">
      {extrationData ? (
        <div className="flex-col h-[calc(100vh-150px)]">
          <div className="flex flex-col px-6 py-2 bg-white">
            <div className="flex items-center justify-between text-black font-bold text-opacity-80">
              <div>Source</div>

              <CloseOutlined onClick={onClose} />
            </div>
            <div className="flex text-black font-medium text-opacity-50">
              <span>{extrationData.table_title}</span>
              <span className="mx-2 h-5 border-0 border-l-2 border-gray-300 border-solid" />
              <span>
                Page #{extrationData.spec_page_extract.spec_page.page_number}
              </span>
              <span className="mx-2 h-5 border-0 border-l-2 border-gray-300 border-solid" />
              <span>
                {extrationData.spec_page_extract.spec_page.specification?.title}
              </span>
            </div>
          </div>
          <CiqDocumentView
            blobKey={extrationData.spec_page_extract.spec_page.page_file_key}
            boundingBoxPossition={boundingBoxPossition}
            auditFeatureType="MATERIALS"
            attachmentId={extrationData.spec_page_extract.id}
            filename={
              extrationData.spec_page_extract.spec_page.specification?.title ||
              ""
            }
          />
        </div>
      ) : (
        <div className="grow w-full h-full bg-gray-500 bg-opacity-60" />
      )}
    </div>
  );
}

export default ExtractedPdfViewer;
